import * as React from "react";
const SvgEmail20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 3h20v14H0V3Zm3.63 2L10 10.662 16.37 5H3.63ZM18 6.227 14.599 9.25 18 13.27V6.227ZM16.844 15l-3.74-4.42L10 13.337l-3.103-2.759L3.157 15h13.687ZM2 13.27V6.227L5.401 9.25 2 13.27Z",
      clipRule: "evenodd"
    })
  );
export default SvgEmail20Px;
